namespace $ {
	/** Arrow Decimal's string contains the signed unscaled integer. */
	export function $shm_duckdb_decimal( value: unknown, scale: number ) {
		if( !Number.isInteger(scale) || scale < 0 || scale > 38 ) {
			throw new Error('DuckDB decimal scale must be an integer from 0 to 38')
		}
		const integer=String(value)
		if( !/^-?\d+$/.test(integer) ) throw new Error('DuckDB decimal must contain an unscaled integer')
		const negative=integer.startsWith('-')
		const digits=negative ? integer.slice(1) : integer
		if( !scale ) return integer
		const padded=digits.padStart(scale+1,'0')
		return (negative ? '-' : '') + padded.slice(0,-scale) + '.' + padded.slice(-scale)
	}
}
